var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-link-item",class:{sub: _vm.sub},attrs:{"to":{
    name: _vm.nav.targetRouterName,
    params :{versions:_vm.nav.versions}
  }}},[_c('span',{on:{"touchstart":function($event){return _vm.report(_vm.nav.targetRouterName, _vm.nav.name)}}},[_vm._v("\n    "+_vm._s(_vm.nav.name))]),_vm._v(" "),(_vm.tabRedPointInfo.num > 0)?_c('b',{staticClass:"red-point",class:{
      on: _vm.tabRedPointInfo.num > 0,
      num: _vm.tabRedPointInfo.type === 'number',
    }},[_vm._v(_vm._s(_vm.tabRedPointInfo.num))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }